import { useMutation } from '@truepill/tpos-react-router'
import { ReactComponent as TimeIcon } from 'assets/icons/time.svg'
import ActionButton from 'components/ActionButton'
import IconWrapper from 'components/IconWrapper'
import { SEND_BACK_TO_ADJUDICATION } from 'gql'
import { useOrderLock } from 'hooks'
import useErrorToast from 'hooks/toast/useErrorToast'
import useSuccessToast from 'hooks/toast/useSuccessToast'
import { bodyPrimaryColor } from 'styles/styleVariables'
import type { Fill, QueueItem } from 'types'
import { getErrorMessage, isOrder, isOrderReadOnly } from 'utils'

type SendBackActionButtonProps = {
  item: QueueItem
  fill: Fill
  isRejectedOrder: boolean
}

export const SendBackActionButton = ({ item, fill, isRejectedOrder }: SendBackActionButtonProps): JSX.Element => {
  const showErrorToast = useErrorToast()
  const showSuccessToast = useSuccessToast()

  const [sendBackToAdjudication] = useMutation(SEND_BACK_TO_ADJUDICATION, {
    refetchQueries: ['getBasicOrder'],
  })

  const isOrderItem = isOrder(item)
  const { orderEditable } = useOrderLock(item._id, !isOrderItem)
  const orderDisabled = isOrderItem && isOrderReadOnly(item)
  const editable = orderEditable && !orderDisabled

  if (isRejectedOrder || !isOrderItem) {
    return <></>
  }

  return (
    <ActionButton
      data-testid="sendToAdjudication"
      disabled={!editable}
      icon={
        <IconWrapper>
          <TimeIcon fill={bodyPrimaryColor} />
        </IconWrapper>
      }
      label={'Send Back'}
      onClick={async () => {
        try {
          const variables = {
            variables: {
              orderId: item._id,
              fillId: fill?._id,
            },
          }
          await sendBackToAdjudication(variables)
          showSuccessToast('Successfully sent back to Adjudication')
        } catch (e) {
          showErrorToast(getErrorMessage(e))
          console.error(e)
        }
      }}
    />
  )
}
